import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import {
    Body1,
    IconFileOpen,
    TextButton,
} from '@myphx-engineering/phx-design-system';

import { GetPriorAuthorizationDownloadsDocument } from '../../../graphql/generated/graphql';
import { useFlags } from '../../../hooks/use-flags';

export const DecisionLetterLink = ({ paId }: { paId: string }) => {
    const { t } = useTranslation();
    const { enablePriorAuthLetterDownload } = useFlags();
    const { data, loading } = useQuery(GetPriorAuthorizationDownloadsDocument, {
        variables: { priorAuthorizationId: paId },
    });

    const documents = data?.priorAuthorization?.documentDownloads ?? [];
    const decisionLetter = documents.find(
        (doc) => doc.documentType.toLowerCase() === 'member letter'
    );

    if (!enablePriorAuthLetterDownload || !decisionLetter) return null;

    return (
        <TextButton
            justify="left"
            loading={loading}
            LeftIcon={IconFileOpen}
            disabled={loading}
            onClick={() => window.open(decisionLetter?.tempUri)}
        >
            <Body1>{t('priorAuth.viewLetter')}</Body1>
        </TextButton>
    );
};
